import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import LogTable from "../components/LogTable";

export default function Employers(props) {
  const {
    chooseRoleId,
    setShowLog,
    showLog,
    onRoleChoose,
  } = props;

  const [logRows, setLogRows] = useState([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if(showLog){
        setIsLoading(true);
        onRoleChoose(chooseRoleId)
          .then((res) => {
            setLogRows(res.data.permission);
            setIsLoading(false);
            setIsError(false);
          })
          .catch((err) => {
            setIsLoading(false);
            setIsError(true);
          });
    }
    
  }, [chooseRoleId , showLog]);


  return (
    <Modal
      show={showLog}
      onHide={setShowLog}
      size="lg"
      aria-labelledby="edit"
      centered
      className="pr-0"
    >
        <Modal.Header closeButton>
          <Modal.Title id="delete">İcazələr</Modal.Title>
        </Modal.Header>
      <Modal.Body>
        <div className="row bg-white rounded">
       
          <LogTable
            logRows={logRows}
            isLoading={isLoading}
            isError={isError}
          />
        </div>
      </Modal.Body>
    </Modal>
  );
}
